<mat-card class="flex-col gt-lg-row wrap flex">
    <mat-card-content>
        <div class="preload-hide cb-margin-bottom" #generateBuildProgrammeContainer>
            @if (canGenerateBuildProgrammeButtonEnabled$ | async) {
                <div class="start-center flex-wrap">
                    <button
                        mat-raised-button
                        class="cb-margin-right"
                        (click)="generateBuildProgramme()"
                    >
                        Generate Build Programme
                    </button>
                </div>
            }
        </div>
        @if (
            lotDto?.hasBuildProgrammeGenerated === true ||
            lotDto?.hasBuildProgrammeTemplateApplied === true
        ) {
            <div class="start-center flex-wrap">
                <div class="start-center flex-wrap layoutGap-8">
                    @if (lotDto?.hasBuildProgrammeGenerated === true) {
                        <span
                            class="inline-tooltip-wrapper cb-margin-bottom"
                            [matTooltip]="getCostActionDisabledText()"
                            [matTooltipDisabled]="!isCostActionDisabled()"
                            matTooltipPosition="above"
                        >
                          <button
                              mat-raised-button
                              [disabled]="isCostActionDisabled()"
                              (click)="createManualOrder()"
                          >
                            Create Manual Order
                          </button>
                        </span>
                    }
                    <button mat-raised-button class="cb-margin-bottom" (click)="generateMultiple()">
                        Generate All PO<small>s</small> &amp; SSR<small>s</small>
                    </button>
                    <span
                        class="inline-tooltip-wrapper cb-margin-bottom"
                        [matTooltip]="getCostActionDisabledText()"
                        [matTooltipDisabled]="!isCostActionDisabled()"
                        matTooltipPosition="above"
                    >
                        <button
                            mat-raised-button
                            (click)="setMultipleSsrConfirmed()"
                            [disabled]="isCostActionDisabled()"
                        >
                          Confirm Multiple
                        </button>
                    </span>
                    <button
                        mat-raised-button
                        class="cb-margin-bottom"
                        (click)="setMultipleSsrCompleted()"
                    >
                        Complete Multiple
                    </button>
                </div>
                <span class="lt-xl-hide flex-0"></span>
                <div class="start-center flex-wrap">
                    @if (
                        lotBuildProgrammeEvents.resolved$$ && !lotBuildProgrammeEvents.hasSummaries
                    ) {
                        <mat-slide-toggle
                            class="cb-margin-top cb-margin-right-2x"
                            [(ngModel)]="lotBuildProgrammeActionBar.reorderingEnabled"
                            [ngModelOptions]="{ standalone: true }"
                            >Enable Reordering
                        </mat-slide-toggle>
                    }
                    <mat-slide-toggle
                        class="cb-margin-top cb-margin-right-2x"
                        [(ngModel)]="lotBuildProgrammeActionBar.viewManualOrders"
                        [ngModelOptions]="{ standalone: true }"
                        >View Manual Orders
                    </mat-slide-toggle>
                    <mat-slide-toggle
                        class="cb-margin-top cb-margin-right-2x"
                        [(ngModel)]="userCache.lotBuildProgrammeView.data.viewAllStages"
                        (change)="viewAllStages()"
                        [ngModelOptions]="{ standalone: true }"
                        >View All Stages
                    </mat-slide-toggle>
                    <span class="lt-xl-100"></span>
                    @if (isJobBuildReportEnabled()) {
                        <cb-lot-build-reports-menu [lot]="lotDto"></cb-lot-build-reports-menu>
                    }
                    <button
                        mat-raised-button
                        ngClass.lt-xl="cb-margin-top"
                        (click)="expandCollapseAll()"
                    >
                        @if (!lotBuildProgrammeActionBar.allExpanded) {
                            <span class="start-center flex-row">
                                <span class="flex">Expand All&nbsp;</span>
                                <mat-icon>keyboard_arrow_down</mat-icon>
                            </span>
                        }
                        @if (lotBuildProgrammeActionBar.allExpanded) {
                            <span class="start-center flex-row">
                                <span class="flex">Collapse All&nbsp;</span>
                                <mat-icon>keyboard_arrow_up</mat-icon>
                            </span>
                        }
                    </button>
                    @if (!fullscreen) {
                        <button
                            class="cb-margin-left"
                            ngClass.lt-xl="cb-margin-top"
                            mat-icon-button
                            (click)="viewFullscreen()"
                        >
                            <mat-icon>fullscreen</mat-icon>
                        </button>
                    }
                </div>
            </div>
        }
    </mat-card-content>
</mat-card>
